import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import ProductsView from "./ProductsView";
import BaseAdminView from "./BaseAdminView";
import CommerceUserView from "./CommerceUserView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor, conditionalWidth } from "../../utils/useful";
import { CommercePages } from "../../variables/AppletPages";
import PagesStackNavigator from "../PagesStackNavigator";


class CommerceApplet extends React.Component {
    state = {
        colors: {
            primaryColor: '#184D94',
            secondaryColor: '#246AC7',
            textColor: '#fff'
        }
    }

    componentDidMount() {

        // console.log("componentDidMount C")

        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }

        let frames = Object.values(CommercePages.pages)
        let framesSections = Object.values(CommercePages.sections)

        this.setState({ frames, framesSections }, () => {
            this.waitForId(10)
        })

    }


    waitForId = (leftAttempt) => {
        // if (this.props.user?.info?._id) {

        this.checkDefaultTab()
        // } else {
        //     setTimeout(() => {
        //         if (leftAttempt != 0) {
        //             this.waitForId(leftAttempt - 1)
        //         } else {
        //             // this.props.actions.logoutUser()
        //             this.setState({ pageStatus: 401 })
        //         }
        //     }, 500);
        // }
    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // console.log('commeerceeeeee', prevProps, this.props.windowData, this.props.lastSelected);
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }



    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page', pageType, def);
            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }

    setData = (key, value, reference, cb) => {
        if (reference == 'CommerceApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }


    render() {



        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`



        return (

            // <div className=" w-100 h-100 window-content-radius scroll-no-scrollbar " style={{ backgroundColor: '#F5F5F5' }}>
            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <BaseAdminView setData={this.setData} stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} appletAccess={this.props.appletAccess} />


                    {/* <div className="h-100 w-100 scroll-no-scrollbar"> */}
                    <CommerceUserView setData={this.setData} stageName={''} baseUrl={this.props.baseUrl} language={this.props.language} colors={colors} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
                    {/* </div> */}


                    {/* <PagesStackNavigator
                        stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} /> */}

                </StagesManager>

            </div>
        )
    }
    //     return (

    //         <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
    //             {this.props.adminView && (
    //                 <BaseAdminView stageName={'admin'} baseUrl={[...this.props.baseUrl, 'admin']} language={this.props.language} width={this.props.width} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
    //             )}

    //             {!this.props.adminView && (

    //                 <div className="h-100 w-100 scroll-no-scrollbar">
    //                     <CommerceUserView stageName={''} baseUrl={this.props.baseUrl} language={this.props.language} width={this.props.width} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
    //                 </div>
    //             )}
    //         </div>


    //     )
    // }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommerceApplet);
